import { faEnvelope } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Typography } from '@mui/material';
import { SubtitlePage, TitlePage, Wrapper } from 'components';
import React, { useEffect } from 'react';
import sanitizeHtml from 'sanitize-html';
import styled from 'styled-components';
import { RGPD_EMAIL } from 'utils/constants';
import { translate } from 'utils/helpers';

const Container = styled.section`
  p {
    margin: 1rem 0;
  }
`;

export const PageRGPD = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Wrapper>
      <TitlePage>{translate('common.personalData')}</TitlePage>
      <SubtitlePage>{translate('personalData.subTitle')}</SubtitlePage>

      <Container>
        <Typography dangerouslySetInnerHTML={{ __html: sanitizeHtml(translate('personalData.intro')) }} />
        <Typography dangerouslySetInnerHTML={{ __html: sanitizeHtml(translate('personalData.usages')) }} />
        <Typography dangerouslySetInnerHTML={{ __html: sanitizeHtml(translate('personalData.rights')) }} />
        <Typography dangerouslySetInnerHTML={{ __html: sanitizeHtml(translate('personalData.cemafroid')) }} />
        <a href={`mailto:${RGPD_EMAIL}`}>
          <FontAwesomeIcon className="mr1" icon={faEnvelope} />
          {RGPD_EMAIL}
        </a>
        <Typography dangerouslySetInnerHTML={{ __html: sanitizeHtml(translate('personalData.answer')) }} />
      </Container>

    </Wrapper>
  );
};
